import React, {Component} from 'react';
import AnswerScreen from './AnswerScreen.jsx';
import QuestionScreen from './QuestionScreen.jsx';
import IntroductionScreen from './IntroductionScreen.jsx';
import DebateScreen from './DebateScreen.jsx';
import DebateWheel from './DebateWheel.jsx';
import ResultScreen from './ResultScreen.jsx';

export default class OpenQuestionHandler extends Component {
    constructor(props) {
        super(props);
    }
    render(){
        let viewComponent = "";
        let viewName = this.props.information.view.split('.').slice(-1)[0];

        switch(viewName){
            //openQuestion.introduction
            case("introduction"):
                viewComponent = (
                    <IntroductionScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                    />
                );
                break;

            //openQuestion.question
            case("question"):
                viewComponent = (
                    <QuestionScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                    />
                );
                break;
            //openQuestion.answer
            case("answer"):
                viewComponent = (
                    <AnswerScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                    />
                );

                break;
            //openQuestion.result
            case("result"):
                viewComponent = (
                    <ResultScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                    />
                );
                break;
            //openQuestion.debateWheel
            case("debateWheel"):
                viewComponent = (
                    <DebateWheel
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                    />
                );
                break;
            //openQuestion.debate
            case("debate"):
                viewComponent = (
                    <DebateScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                    />
                );
                break;
            default:
                viewComponent = null;
                break;
                
        }
            return (
                <div className ="screen-container">
                    {viewComponent}
                </div>
            );
    }
}